"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockedMetricsUtilsDataSource = void 0;
const constants_1 = require("gather-common/dist/src/public/constants");
const mockedResult = { event: undefined, code: undefined, message: undefined };
exports.mockedMetricsUtilsDataSource = {
    getDefaultDeviceId: async () => undefined,
    getDeviceId: () => undefined,
    getPlatform: () => constants_1.Platform.DesktopWeb,
    gtagEvent: () => { },
    onDeviceId: () => { },
    runOnNextIdleCb: () => { },
    groupIdentify: () => new Promise(() => mockedResult),
    identify: () => new Promise(() => mockedResult),
    logEvent: () => new Promise(() => mockedResult),
    setDeviceId: () => new Promise(() => mockedResult),
    setGroup: () => new Promise(() => mockedResult),
    setUserId: () => new Promise(() => mockedResult),
};
//# sourceMappingURL=MetricsUtilsDataSource.js.map